module.exports = __webpack_public_path__ + "static/img/peizhitixi.3edd50b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/peizhitixi.jpg
// module id = X1yN
// module chunks = 1